export const UPDATE_DEALER_CREDENTIALS = 'UPDATE_DEALER_CREDENTIALS';
export const UPDATE_DEALER_CREDENTIALS_SUCCESSFUL = 'UPDATE_DEALER_CREDENTIALS_SUCCESSFUL';
export const UPDATE_DEALER_CREDENTIALS_FAILED = "UPDATE_DEALER_CREDENTIALS_FAILED";
export const RESET_ALERT = "RESET_ALERT";

